<template>
    <v-container style="padding-top: 80px">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-col cols="12" md="12">
                <v-card class="mb-10 text-xs-center ">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Pre Alta de Usuarios</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row v-if="listado.length > 0">
                            <v-col v-for="(item, index) in listado" :key="index" cols="12" sm="6" md="4" lg="3">
                                <v-card class="UserCard">
                                    <v-card-title v-if="item.prestatus == 'A'" class="pa-5 pb-3 cardTittle">
                                        <p style="color: white; font-size:15px"> <span
                                                style="color: white; font-size:15px" class="font-weight-bold"> Clave:
                                            </span>{{ item.prclave }}</p>
                                    </v-card-title>
                                    <v-card-text>
                                        <div class="mx-auto text-center" style="margin-top: 2vh; margin-bottom: 2vh">
                                            <v-badge class="badgeClass" offset-y="15" offset-x="18" overlap bottom
                                                color="green" icon="mdi-check">
                                                <v-avatar size="61">
                                                    <v-img src="https://ausa.com.mx/img/Images/perfil.png"
                                                        alt="Avatar"></v-img>
                                                </v-avatar>
                                            </v-badge>
                                        </div>
                                        <div class="datosDiv">
                                            <v-card-text><span class="font-weight-bold">Nombre:</span>
                                                {{ item.Nombre }}</v-card-text>
                                            <v-card-text><span class="font-weight-bold">Puesto:</span>
                                                {{ item.pudescripcion }}</v-card-text>
                                            <v-card-text><span class="font-weight-bold">Fecha de alta:</span>
                                                {{ item.paualta }}</v-card-text>
                                        </div>
                                        <v-spacer></v-spacer>
                                        <div>
                                            <v-row justify="center">
                                                <v-btn outlined style="align-self:center" :color="item.color"
                                                    @click="DetallePreUsuario(item)">
                                                    Más Información
                                                </v-btn>
                                            </v-row>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row v-else>
                            <v-col cols="12">
                                <h5 style="text-align: center;">No hay pre altas por autorizar</h5>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import PreAlta from "@/services/PreAlta/preAlta.service.js";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
    },
    data() {
        return {
            showcargando: true,
            permisoPreAlta: false,
            uslogin: '',
            noResults: false,
            listado: [],
        }
    },
    computed: {
        ...mapState(['permission', 'domain']),
        ...mapGetters(['getUser', 'THEME_STATE'])
    },
    methods: {
        async DetallePreUsuario(item) {
            let datos = {
                pauid: item.pauid,
            }
            await MetodosGenerales.guardarEnSesionInfoReporte(datos, 'preusr');
            this.$router.push({ name: 'DetallePreUsuario' }).catch((error) => error);
        }
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '376').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 376)//Permiso para ver las prealtas
                        this.permisoPreAlta = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        this.uslogin = await MetodosGenerales.ObtenerUserName();
        let response = await PreAlta.ListadoSolicitudes(this.uslogin);
        this.noResults = response.length > 0 ? false : true;
        this.listado = response;
        this.showcargando = false;

    }
}
</script>
<style>
.UserCard {
    min-height: 440px !important;
    max-height: 440px !important;
    height: auto;
}

.datosDiv {
    height: 290px !important;
    overflow-y: hidden !important;
}
</style>